import { Utils } from './utils';
const formSelector = ".newsletter-signup-form";
const validationRules = {
    Email: {
        required: true,
        email: true
    },
    PrivacyPolicyAccepted: {
        required: true
    }
};
const validationMessages = {
    Email: {
        required: "Please enter your email",
        email: "Please enter a valid email address"
    },
    PrivacyPolicyAccepted: {
        required: "Please accept our privacy policy"
    }
};
export class NewsletterSignup {
    /**
     * If the page contains any newsletter signup forms, initialize the validation settings for those forms. Not all
     * forms are validated this way.
     */
    InitializeFormValidation() {
        Utils.InitializeFormValidation(formSelector, validationRules, validationMessages);
    }
}
